export default __webpack_public_path__ + "static/media/vuetifyjs.4802839b.svg";